function fetchProductNameSuggestions(query) {
  var url = '/search/suggest.json'
    + '?q=' + encodeURIComponent(query)
    + '&resources[type]=product'
    + '&resources[limit]=10'
    + '&resources[options][unavailable_products]=last';
  return fetch(url, { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (data) {
      if (!data || !data.resources || !data.resources.results) return [];
      var products = data.resources.results.products || [];
      var bases = {};
      var out = [];
      products.forEach(function (p) {
        var base = (p.title || '').split(' - ')[0].trim();
        if (base && !bases[base.toLowerCase()]) {
          bases[base.toLowerCase()] = true;
          out.push(base);
        }
      });
      return out;
    })
    .catch(function () { return []; });
}

document.addEventListener('DOMContentLoaded', function () {
  var url = new URL(window.location.href);
  var pn = url.searchParams.get('pn');
  if (!pn) return;
  var pnLower = pn.toLowerCase();

  if (window.posthog) posthog.capture('Products Searched', { query: pn });

  function showSearchEmpty() {
    if (window.posthog) posthog.capture('Search No Results', { query: pn });
    var grid = document.getElementById('product-grid');
    if (grid) grid.hidden = true;
    var pagination = document.querySelector('.pagination');
    if (pagination) pagination.hidden = true;
    var empty = document.querySelector('[data-search-empty]');
    if (empty) {
      var tpl = empty.getAttribute('data-no-results-template') || 'Aucun résultat pour « %QUERY% »';
      var textEl = empty.querySelector('[data-search-empty-text]');
      if (textEl) textEl.textContent = tpl.replace('%QUERY%', pn);
      empty.hidden = false;
    }
  }

  var vendorsContainer = document.querySelector('[data-all-vendors]');
  var vendors = vendorsContainer && vendorsContainer.dataset.allVendors
    ? vendorsContainer.dataset.allVendors.split('|||')
    : [];
  var vendorMatch = null;
  for (var i = 0; i < vendors.length; i++) {
    if (vendors[i].toLowerCase() === pnLower) { vendorMatch = vendors[i]; break; }
  }
  if (vendorMatch) {
    url.searchParams.delete('pn');
    url.searchParams.append('filter.p.vendor', vendorMatch);
    window.location.replace(url.toString());
    return;
  }

  var container = document.querySelector('[data-expand-base="true"]');
  var allValues = container && container.dataset.allValues
    ? container.dataset.allValues.split('|||')
    : [];
  var matches = allValues.filter(function (v) {
    var vLower = v.toLowerCase();
    return vLower === pnLower || vLower.indexOf(pnLower + ' ') === 0;
  });
  if (matches.length > 0) {
    url.searchParams.delete('pn');
    matches.forEach(function (m) {
      url.searchParams.append('filter.p.m.quelbonplan.product-name', m);
    });
    window.location.replace(url.toString());
    return;
  }

  fetchProductNameSuggestions(pn).then(function (names) {
    var filtered = names.filter(function (n) {
      return n.toLowerCase().indexOf(pnLower) !== -1;
    });
    if (filtered.length > 0) {
      url.searchParams.delete('pn');
      filtered.forEach(function (n) {
        url.searchParams.append('filter.p.m.quelbonplan.product-name', n);
      });
      window.location.replace(url.toString());
      return;
    }
    showSearchEmpty();
  });
});

var STOCK_SORT_VALUE = 'quantity-descending';

// MVP WRK-580: tri par stock décroissant côté client (page courante uniquement).
// Shopify n'expose pas de sort_by natif par inventaire ; on réordonne le grid
// rendu par data-initial-stock. Le tri global multi-pages relève d'une V2 backend.
//
// Stock-desc est l'ordre PAR DÉFAUT (vue de base ET vues filtrées) pour que les
// régimes de TVA soient mélangés, pas groupés. Seul un sort_by explicite choisi
// par le visiteur (prix, titre, nouveautés, meilleures ventes) le remplace.
function reorderGridByStock() {
  if (new URL(window.location.href).searchParams.get('sort_by')) return;
  ['sort-by', 'sort-by-mobile'].forEach(function (id) {
    var sel = document.getElementById(id);
    if (sel) sel.value = STOCK_SORT_VALUE;
  });
  var grid = document.getElementById('product-grid');
  if (!grid) return;
  var cards = Array.prototype.slice.call(grid.querySelectorAll('.product-card'));
  cards.sort(function (a, b) {
    return (parseInt(b.dataset.initialStock, 10) || 0) - (parseInt(a.dataset.initialStock, 10) || 0);
  });
  cards.forEach(function (card) { grid.appendChild(card); });
}
document.addEventListener('DOMContentLoaded', reorderGridByStock);

function syncCardStock() {
  return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
    var byVariant = {};
    cart.items.forEach(function (it) { byVariant[it.variant_id] = (byVariant[it.variant_id] || 0) + it.quantity; });
    document.querySelectorAll('.product-card[data-variant-id]').forEach(function (card) {
      var vid = parseInt(card.dataset.variantId, 10);
      var initial = parseInt(card.dataset.initialStock, 10) || 0;
      var used = byVariant[vid] || 0;
      var remaining = Math.max(0, initial - used);
      var count = card.querySelector('.product-card__stock-count');
      if (count) count.textContent = remaining;
      var qtyInput = card.querySelector('.product-card__qty-input');
      var addBtn = card.querySelector('.product-card__add-btn');
      var minusBtn = card.querySelector('[data-qty-action="minus"]');
      var plusBtn = card.querySelector('[data-qty-action="plus"]');
      if (qtyInput) {
        qtyInput.max = remaining;
        if (parseInt(qtyInput.value, 10) > remaining) qtyInput.value = Math.max(1, remaining);
      }
      var soldOut = remaining <= 0;
      if (addBtn) {
        addBtn.disabled = soldOut;
        if (used > 0) {
          if (!addBtn.dataset.originalText) {
            addBtn.dataset.originalText = addBtn.textContent.trim();
          }
          if (!addBtn.classList.contains('product-card__add-btn--success')) {
            addBtn.textContent = 'Ajouté ✓';
            addBtn.classList.add('product-card__add-btn--success');
          }
        }
      }
      if (minusBtn) minusBtn.disabled = soldOut;
      if (plusBtn) plusBtn.disabled = soldOut;
      if (qtyInput) qtyInput.disabled = soldOut;
    });
  });
}
document.addEventListener('DOMContentLoaded', syncCardStock);


document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-qty-action]');
  if (!btn) return;
  var input = btn.parentElement.querySelector('.product-card__qty-input');
  if (!input) return;
  var val = parseInt(input.value) || 1;
  var min = parseInt(input.min) || 1;
  if (btn.dataset.qtyAction === 'minus') {
    input.value = Math.max(min, val - 1);
  } else {
    input.value = val + 1;
  }
});

document.addEventListener('submit', function (e) {
  var form = e.target.closest('.product-card__cart form');
  if (!form) return;
  e.preventDefault();
  e.stopPropagation();

  var addBtn = form.querySelector('.product-card__add-btn');
  if (!addBtn.dataset.originalText) {
    addBtn.dataset.originalText = addBtn.textContent.trim();
  }
  var originalText = addBtn.dataset.originalText;
  addBtn.disabled = true;

  var formData = new FormData(form);
  fetch('/cart/add.js', {
    method: 'POST',
    body: formData
  })
    .then(function (res) { return res.json(); })
    .then(function (item) {
      if (window.posthog && item && item.id) {
        posthog.capture('Product Added', {
          product_id: item.product_id,
          variant_id: item.variant_id || item.id,
          sku: item.sku,
          name: item.product_title,
          variant: item.variant_title,
          quantity: item.quantity,
          price: item.price / 100,
          line_price: item.line_price / 100,
          currency: 'EUR'
        });
      }
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        var cartLink = document.querySelector('.header__cart');
        if (cartLink) {
          var badge = cartLink.querySelector('.header__cart-badge');
          if (cart.item_count > 0) {
            if (!badge) {
              badge = document.createElement('span');
              badge.className = 'header__cart-badge';
              cartLink.appendChild(badge);
            }
            badge.textContent = cart.item_count;
          } else if (badge) {
            badge.remove();
          }
        }
        // Large-order prompt: pop the quote modal if the cart reached the threshold.
        if (window.QBPLargeOrder) window.QBPLargeOrder.maybeShow(cart.item_count);
      });
      var qtyInput = form.querySelector('.product-card__qty-input');
      if (qtyInput) qtyInput.value = 1;
      syncCardStock();
      addBtn.textContent = 'Ajouté ✓';
      addBtn.classList.add('product-card__add-btn--success');
      addBtn.disabled = false;
    })
    .catch(function () {
      addBtn.textContent = 'Erreur';
      setTimeout(function () {
        addBtn.textContent = originalText;
        addBtn.disabled = false;
      }, 1500);
    });
});

function resetAddBtn(btn) {
  if (!btn || !btn.classList.contains('product-card__add-btn--success')) return;
  var original = btn.dataset.originalText;
  if (original) btn.textContent = original;
  btn.classList.remove('product-card__add-btn--success');
}

document.addEventListener('input', function (e) {
  if (!e.target.classList || !e.target.classList.contains('product-card__qty-input')) return;
  var card = e.target.closest('.product-card');
  if (card) resetAddBtn(card.querySelector('.product-card__add-btn'));
});

document.addEventListener('click', function (e) {
  var qtyBtn = e.target.closest('.product-card__qty-btn');
  if (!qtyBtn) return;
  var card = qtyBtn.closest('.product-card');
  if (card) resetAddBtn(card.querySelector('.product-card__add-btn'));
});

document.addEventListener('DOMContentLoaded', function () {
  initAutoComplete('product');
  initAutoComplete('color');
  initAutoComplete('release-year');

  var mobileQuery = window.matchMedia('(max-width: 768px)');
  function isMobile() { return mobileQuery.matches; }

  var sortSelect = document.getElementById('sort-by');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      if (this.value === STOCK_SORT_VALUE) {
        url.searchParams.set('stock_sort', 'desc');
        url.searchParams.delete('sort_by');
      } else {
        url.searchParams.set('sort_by', this.value);
        url.searchParams.delete('stock_sort');
      }
      window.location.href = url.toString();
    });
  }

  var filterTrigger = document.getElementById('filter-trigger');
  var filtersPanel = document.getElementById('collection-filters');
  var filtersOverlay = document.getElementById('filters-overlay');
  var filtersClose = document.getElementById('filters-close');

  function openFilters() {
    if (filtersPanel) filtersPanel.classList.add('is-open');
    if (filtersOverlay) filtersOverlay.classList.add('is-open');
    document.documentElement.classList.add('is-filters-open');
    document.body.classList.add('is-filters-open');
  }
  function closeFilters() {
    if (filtersPanel) filtersPanel.classList.remove('is-open');
    if (filtersOverlay) filtersOverlay.classList.remove('is-open');
    document.documentElement.classList.remove('is-filters-open');
    document.body.classList.remove('is-filters-open');
  }

  if (filterTrigger) filterTrigger.addEventListener('click', openFilters);
  if (filtersOverlay) filtersOverlay.addEventListener('click', closeFilters);
  if (filtersClose) filtersClose.addEventListener('click', closeFilters);

  var toggleAll = document.getElementById('filters-toggle-all');
  if (toggleAll) {
    toggleAll.addEventListener('click', function () {
      var details = document.querySelectorAll('.filter-group');
      var allOpen = Array.from(details).every(function (d) { return d.open; });
      details.forEach(function (d) { d.open = !allOpen; });
      toggleAll.textContent = allOpen ? 'Tout déplier' : 'Tout replier';
    });
  }

  function positionTooltip(el) {
    var tooltip = el.querySelector('.filter-group__tooltip');
    if (!tooltip) return;
    var iconRect = el.getBoundingClientRect();
    var tipWidth = tooltip.offsetWidth || 320;
    var tipHeight = tooltip.offsetHeight || 0;
    var margin = 12;
    var left = iconRect.left;
    if (left + tipWidth > window.innerWidth - margin) {
      left = window.innerWidth - tipWidth - margin;
    }
    if (left < margin) left = margin;
    var top = iconRect.bottom + 8;
    if (tipHeight && top + tipHeight > window.innerHeight - margin) {
      var topAbove = iconRect.top - tipHeight - 8;
      if (topAbove >= margin) top = topAbove;
    }
    tooltip.style.left = left + 'px';
    tooltip.style.top = top + 'px';
  }

  document.querySelectorAll('.filter-group__info').forEach(function (el) {
    el.addEventListener('mouseenter', function () { positionTooltip(el); });
    el.addEventListener('focus', function () { positionTooltip(el); });
    el.addEventListener('click', function (e) {
      // Tax-type icon opens the modal instead of toggling its tooltip on tap.
      if (el.hasAttribute('data-tax-info-open')) return;
      e.preventDefault();
      e.stopPropagation();
      var wasOpen = el.classList.contains('is-open');
      document.querySelectorAll('.filter-group__info.is-open').forEach(function (o) { o.classList.remove('is-open'); });
      if (!wasOpen) {
        positionTooltip(el);
        el.classList.add('is-open');
      }
    });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.filter-group__info')) {
      document.querySelectorAll('.filter-group__info.is-open').forEach(function (o) { o.classList.remove('is-open'); });
    }
  });
  window.addEventListener('scroll', function () {
    document.querySelectorAll('.filter-group__info.is-open').forEach(function (o) { o.classList.remove('is-open'); });
  }, true);

  // Tax-info modal — opened by the "Plus d'infos" buttons next to the tax-type filter.
  var taxModal = document.getElementById('tax-info-modal');
  if (taxModal) {
    var openTaxModal = function () {
      taxModal.hidden = false;
      document.body.classList.add('is-tax-info-open');
    };
    var closeTaxModal = function () {
      taxModal.hidden = true;
      document.body.classList.remove('is-tax-info-open');
    };
    document.querySelectorAll('[data-tax-info-open]').forEach(function (btn) {
      var trigger = function (e) {
        e.preventDefault();
        e.stopPropagation();
        openTaxModal();
      };
      btn.addEventListener('click', trigger);
      // <span> triggers (the info icon) need explicit keyboard activation; <button> handles it natively.
      if (btn.tagName !== 'BUTTON') {
        btn.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') trigger(e);
        });
      }
    });
    taxModal.querySelectorAll('[data-tax-info-close]').forEach(function (el) {
      el.addEventListener('click', closeTaxModal);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !taxModal.hidden) closeTaxModal();
    });
  }

  var filterForm = document.getElementById('filters-form');
  var sortMobile = document.getElementById('sort-by-mobile');

  // High-stock default opt-out: when the visitor deliberately drops the
  // auto-applied "> 100" quantity filter, remember it for the session so the
  // landing redirect (sections/collection.liquid) stops re-forcing it.
  var QTY_FILTER_PARAM = 'filter.p.m.quelbonplan.quantity';
  function markQtyOptOut() {
    try { sessionStorage.setItem('qbp_qty_filter_optout', '1'); } catch (e) {}
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.filter-pill--clear, [data-qty-optout], #filters-reset')) {
      markQtyOptOut();
    }
  });

  function buildFilterUrl() {
    var url = new URL(window.location.origin + window.location.pathname);
    var currentParams = new URL(window.location.href).searchParams;
    var currentSort = currentParams.get('sort_by');
    var currentStockSort = currentParams.get('stock_sort') === 'desc' ? STOCK_SORT_VALUE : null;
    var mobileSort = (isMobile() && sortMobile) ? sortMobile.value : null;
    var sortToApply = mobileSort || currentSort || currentStockSort;
    if (sortToApply === STOCK_SORT_VALUE) {
      url.searchParams.set('stock_sort', 'desc');
    } else if (sortToApply) {
      url.searchParams.set('sort_by', sortToApply);
    }

    if (!filterForm) return url;

    filterForm.querySelectorAll('.filter-group:open').forEach(function (container) {
      url.searchParams.append('filter_open', container.dataset.name);
    })

    filterForm.querySelectorAll('input[type="checkbox"]:checked').forEach(function (input) {
      url.searchParams.append(input.name, input.value);
    });
    filterForm.querySelectorAll('input[type="number"]').forEach(function (input) {
      if (input.value) url.searchParams.set(input.name, input.value);
    });
    filterForm.querySelectorAll('[data-filter-tags]').forEach(function (container) {
      const param = container.dataset.param;

      for (const value of currentParams.getAll(param)) {
        url.searchParams.append(param, value);
      }
      
      const input = container.querySelector('.autocomplete-input');

      if (input.value.trim().length > 0) {
        url.searchParams.append(param, input.value);
      }
    });

    return url;
  }

  function validatePriceInputs() {
    if (!filterForm) return;
    var priceInputs = filterForm.querySelectorAll('.filter-group__price-range input[type="number"]');
    var minInput = null, maxInput = null;
    priceInputs.forEach(function (inp) {
      if (inp.id.indexOf('filter-price-min-') === 0) minInput = inp;
      if (inp.id.indexOf('filter-price-max-') === 0) maxInput = inp;
    });
    if (minInput && minInput.value !== '' && parseFloat(minInput.value) < 0) minInput.value = '0';
    if (maxInput && maxInput.value !== '' && parseFloat(maxInput.value) < 0) maxInput.value = '';
    if (minInput && maxInput && minInput.value !== '' && maxInput.value !== '') {
      var minV = parseFloat(minInput.value);
      var maxV = parseFloat(maxInput.value);
      if (maxV < minV) { minInput.value = String(maxV); maxInput.value = String(minV); }
    }
  }

  function applyFiltersNow() {
    validatePriceInputs();
    window.location.href = buildFilterUrl().toString();
  }

  if (filterForm) {
    const currentParams = new URL(window.location.href).searchParams;

    for (const openFilter of currentParams.getAll('filter_open')) {
      const element = document.querySelector(`.filter-group[data-name="${CSS.escape(openFilter)}"]`);
      if (!element) {
        continue;
      }

      element.open = true;
    }
    
    filterForm.addEventListener('change', function (e) {
      if (e.target && e.target.name === QTY_FILTER_PARAM) {
        if (e.target.checked) {
          try { sessionStorage.removeItem('qbp_qty_filter_optout'); } catch (err) {}
        } else {
          markQtyOptOut();
        }
      }
      if (isMobile()) return;
      if (e.target && e.target.matches('.filter-group__price-range input[type="number"]')) return;
      applyFiltersNow();
    });

    filterForm.querySelectorAll('.filter-group__price-range input[type="number"]').forEach(function (inp) {
      if (currentParams.has(inp.name)) {
        inp.value = currentParams.get(inp.name);
      }

      inp.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); applyFiltersNow(); }
      });
      inp.addEventListener('blur', function (event) {
        if (isMobile()) return;
        if (!event.target.value) return;
        applyFiltersNow();
      });
    });
  }

  var filtersApply = document.getElementById('filters-apply');
  if (filtersApply) {
    filtersApply.addEventListener('click', applyFiltersNow);
  }

  function initAutoComplete(prefix) {
    const inputElement = document.getElementById(`${prefix}-autocomplete-input`);
    const suggestionList = document.getElementById(`${prefix}-autocomplete-list`);

    const dataList = inputElement.parentElement.parentElement.dataset.allValues.split('|||');
    let currentFocus = -1;

    inputElement.addEventListener("input", autoComplete);
    inputElement.addEventListener("focus", autoComplete);

    function autoComplete(event) {
      const val = event.target.value;
    
      // Réinitialiser la liste
      suggestionList.innerHTML = "";
      currentFocus = -1;

      // Filtrer les données (insensible à la casse)
      const filteredData = dataList.filter(item => 
        item.toLowerCase().includes(val.toLowerCase())
      );

      if (filteredData.length === 0) {
        suggestionList.classList.add("hidden");
        return;
      }

      // Afficher la liste et la peupler
      suggestionList.classList.remove("hidden");

      filteredData.forEach(item => {
        const li = document.createElement("li");
      
        // Mettre en gras la partie correspondante (optionnel mais visuellement sympa)
        const regex = new RegExp(`(${val})`, "gi");
        li.innerHTML = item.replace(regex, "<strong>$1</strong>");

        // Gérer le clic sur une suggestion
        li.addEventListener("click", function() {
          inputElement.value = item;
          closeAllLists();
          applyFiltersNow();
        });

        suggestionList.appendChild(li);
      });
    }

    inputElement.addEventListener("keydown", function(e) {
      const items = suggestionList.getElementsByTagName("li");
    
      if (e.key === "ArrowDown") {
        currentFocus++;
        addActive(items);
      } else if (e.key === "ArrowUp") {
        currentFocus--;
        addActive(items);
      } else if (e.key === "Enter") {
        e.preventDefault();
        if (currentFocus > -1) {
          if (items) items[currentFocus].click();
        }
      }
    });

    function addActive(items) {
      if (!items || items.length === 0) return false;
      removeActive(items);
      if (currentFocus >= items.length) currentFocus = 0;
      if (currentFocus < 0) currentFocus = (items.length - 1);
      items[currentFocus].classList.add("active");
    
      // Scroll automatique pour garder l'élément visible
      items[currentFocus].scrollIntoView({ block: "nearest" });
    }

    function removeActive(items) {
      for (let i = 0; i < items.length; i++) {
        items[i].classList.remove("active");
      }
    }

    function closeAllLists() {
      suggestionList.innerHTML = "";
      suggestionList.classList.add("hidden");
    }

    document.addEventListener("click", function(e) {
      if (e.target !== inputElement) {
        closeAllLists();
      }
    });
  }
});
